import {
  CreateUpdateAttachmentDtoEnObjectTypeEnum,
  CreateUpdateAttachmentsDto,
} from '../../pokCore/autogenerated/pokApiClient';
import { newAttachmentForObject } from '../../pokCore/contexts/AttachmentContext';

import { NewFile } from './DragNDropFiles';

export const convertUploadedFilesToAttachments = (
  uploadedFiles: NewFile[],
  filesToDelete: string[],
  objectId: string,
  ObjectType: CreateUpdateAttachmentDtoEnObjectTypeEnum,
): CreateUpdateAttachmentsDto => {
  const attachmentsToAdd = uploadedFiles.map(att => {
    const attachment = newAttachmentForObject(ObjectType, objectId);
    return {
      ...attachment,
      name: att.name,
      fileContent: att.content.toString('base64'),
    };
  });
  return {
    attachmentsToAdd: attachmentsToAdd,
    attachmentsToDelete: filesToDelete,
  };
};
